<template>
  <div>
    <va-card>
      <va-data-table
        :fields="fields"
        :data="callbacks"
        :loading="loading"
        :per-page="10"
        class="va-table va-table--hoverable"
        no-data-label="Пусто"
      >
        <template slot="created_at" slot-scope="props">
          <span
            :class="{ 'callbacks-highlight-cell': isWholesaleSource(props.rowData) }"
          >
            {{ formatDate(props.rowData.created_at) }}
          </span>
        </template>
        <template slot="status" slot-scope="props">
          <span
            :class="{ 'callbacks-highlight-cell': isWholesaleSource(props.rowData) }"
          >
            {{ formatStatus(props.rowData.status) }}
          </span>
        </template>
        <template slot="name" slot-scope="props">
          <span
            :class="{ 'callbacks-highlight-cell': isWholesaleSource(props.rowData) }"
          >
            {{ props.rowData.name }}
          </span>
        </template>
        <template slot="phone" slot-scope="props">
          <span
            :class="{ 'callbacks-highlight-cell': isWholesaleSource(props.rowData) }"
          >
            {{ props.rowData.phone }}
          </span>
        </template>
        <template slot="callback_source" slot-scope="props">
          <span
            :class="{ 'callbacks-highlight-cell': isWholesaleSource(props.rowData) }"
          >
            {{ props.rowData.callback_source || '-' }}
          </span>
        </template>
        <template slot="processed_at" slot-scope="props">
          <span
            :class="{ 'callbacks-highlight-cell': isWholesaleSource(props.rowData) }"
          >
            {{ formatDate(props.rowData.processed_at) }}
          </span>
        </template>
        <template slot="cancelled_at" slot-scope="props">
          <span
            :class="{ 'callbacks-highlight-cell': isWholesaleSource(props.rowData) }"
          >
            {{ formatDate(props.rowData.cancelled_at) }}
          </span>
        </template>
        <template slot="actions" slot-scope="props">
          <div
            class="callbacks-actions"
            :class="{ 'callbacks-highlight-actions': isWholesaleSource(props.rowData) }"
          >
            <va-button
              v-if="props.rowData.status === 'new'"
              small
              color="info"
              @click="setStatus('processed', props.rowData)"
            >
              Обработана
            </va-button>
            <va-button
              v-if="props.rowData.status === 'new'"
              small
              color="danger"
              @click="setStatus('cancelled', props.rowData)"
            >
              Отменена
            </va-button>
          </div>
        </template>
      </va-data-table>
    </va-card>
  </div>
</template>

<script>
import api from "@/api/axios";

export default {
  name: "CallbacksTable",
  props: {
    callbacks: {
      type: Array,
      required: true,
      default: () => [],
    },
    loading: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    fields() {
      return [
        {
          name: "__slot:created_at",
          title: "Время заявки",
        },
        {
          name: "__slot:status",
          title: "Статус",
        },
        {
          name: "__slot:name",
          title: "Имя",
        },
        {
          name: "__slot:phone",
          title: "Телефон",
        },
        {
          name: "__slot:callback_source",
          title: "Источник",
        },
        {
          name: "__slot:processed_at",
          title: "Обработана",
        },
        {
          name: "__slot:cancelled_at",
          title: "Отменена",
        },
        {
          name: "__slot:actions",
          title: "",
          width: "220px",
        },
      ];
    },
  },
  methods: {
    isWholesaleSource(callback) {
      return callback && callback.callback_source === 'Оптовик'
    },
    formatStatus(status) {
      if (status === "processed") return "Обработана";
      if (status === "cancelled") return "Отменена";
      return "Новая";
    },
    formatDate(date) {
      if (!date) return "-";
      try {
        const d = new Date(date);
        return d.toLocaleString("ru-RU", { timeZone: "Asia/Omsk" });
      } catch (e) {
        return date;
      }
    },
    async setStatus(status, callback) {
      try {
        await api.post(`/admin/callbacks/${callback.id}/${status}`);
        this.$emit("refresh");
      } catch (error) {
        console.error("Ошибка смены статуса заявки:", error);
        alert("Ошибка при смене статуса");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.callbacks-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  align-items: center;
}

.callbacks-highlight-cell {
  display: block;
  width: 100%;
  background: rgba(59, 130, 246, 0.12);
  border-radius: 4px;
  padding: 2px 6px;
}

.callbacks-highlight-actions {
  background: rgba(59, 130, 246, 0.12);
  border-radius: 4px;
  padding: 2px 6px;
}
</style>
